import { BANNER_IMAGE_URL, BANNER_IMAGE_URL_HIGH_DPI } from '@/components/HowToWin/helpers/constants';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';

export const HowToWinBannerBigImage = () => {
    const { formatMessage } = useIntl();

    return (
        <div className="relative aspect-[486/240] w-[50%] min-w-0 max-w-[486px] shrink-0">
            <img
                alt={formatMessage({ id: 'howToWinBanner.imageAlt' })}
                className="h-full w-full rounded-md object-contain"
                loading="lazy"
                src={BANNER_IMAGE_URL}
                srcSet={`${BANNER_IMAGE_URL_HIGH_DPI} 2x`}
            />
        </div>
    );
};
